// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TokenService = Symbol('TokenService');
